import { render, staticRenderFns } from "./ListDocumentsTable.vue?vue&type=template&id=8ac67738&"
import script from "./ListDocumentsTable.vue?vue&type=script&lang=js&"
export * from "./ListDocumentsTable.vue?vue&type=script&lang=js&"
import style0 from "./ListDocumentsTable.vue?vue&type=style&index=0&id=8ac67738&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ac67738')) {
      api.createRecord('8ac67738', component.options)
    } else {
      api.reload('8ac67738', component.options)
    }
    module.hot.accept("./ListDocumentsTable.vue?vue&type=template&id=8ac67738&", function () {
      api.rerender('8ac67738', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ListDocumentsTable.vue"
export default component.exports